import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-caption text-grey" }
const _hoisted_2 = { key: 1 }

import { ref, onMounted } from 'vue';
import { api } from '@/services/api';
import type Client from '@/models/client';


export default /*@__PURE__*/_defineComponent({
  __name: 'Overview',
  setup(__props) {

const customers = ref<Client[]>([]);
const errorCounts = ref<Record<string, number>>({});
const loading = ref(false);

const getTokenStatusColor = (status: string) => {
  switch (status) {
    case 'Active':
      return 'success';
    case 'PendingAuthorization':
      return 'warning';
    case 'Expired':
    case 'Inactive':
    case 'Disabled':
    case 'Invalid':
    case 'Revoked':
      return 'error';
    default:
      return 'grey';
  }
};

const fetchCustomerErrors = async (customerId: string) => {
  try {
    const customerData = await api.getClient(customerId);
    if (customerData.errors) {
      errorCounts.value[customerId] = customerData.errors.length;
    }
  } catch (error) {
    console.error(`Error fetching errors for customer ${customerId}:`, error);
    errorCounts.value[customerId] = 0;
  }
};

const refreshData = async () => {
  loading.value = true;
  try {
    customers.value = await api.getClients();
    errorCounts.value = {};
    
    // Fetch errors for each customer
    await Promise.all(
      customers.value.map(customer => fetchCustomerErrors(customer.id))
    );
  } catch (error) {
    console.error('Error fetching customers:', error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  refreshData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createTextVNode(" Customers Overview ")),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                "prepend-icon": "mdi-refresh",
                loading: loading.value,
                onClick: refreshData
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Refresh ")
                ])),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_table, null, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Client Name"),
                      _createElementVNode("th", null, "Contact"),
                      _createElementVNode("th", null, "Token Status"),
                      _createElementVNode("th", null, "Errors"),
                      _createElementVNode("th", null, "Actions")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customers.value, (customer) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: customer.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(customer.name), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(customer.contactName), 1),
                          _createElementVNode("div", _hoisted_1, _toDisplayString(customer.contactEmail), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_v_chip, {
                            color: getTokenStatusColor(customer.tokenStatus),
                            size: "small",
                            variant: "elevated"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(customer.tokenStatus), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ]),
                        _createElementVNode("td", null, [
                          (errorCounts.value[customer.id])
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                color: "error",
                                size: "small",
                                variant: "elevated"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(errorCounts.value[customer.id]) + " errors ", 1)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("span", _hoisted_2, "No errors"))
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            size: "small",
                            to: `/client/${customer.id}`,
                            color: "primary"
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode(" View Details ")
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})